export const entityList = {
  order_page: {
    label: 'Страница заказа',
  },
  customer_page: {
    label: 'Страница клиента',
    disabled: true,
  },
  measurement_page: {
    label: 'Страница замера',
    disabled: true,
  },
  montage_page: {
    label: 'Страница монтажа',
    disabled: true,
  },
  hr_page: {
    label: 'Страница отклика (HR)',
  },
  claim_page: {
    label: 'Карточка рекламации',
  },
}
